import { createAction, props } from '@ngrx/store';
import { LandRegistry } from '../_models';

// Action types
export const loadLandRegistries = createAction('[LandRegistry] Load LandRegistries');
export const loadLandRegistriesSuccess = createAction(
  '[LandRegistry] Load LandRegistries Success',
  props<{ landRegistries: LandRegistry[] }>()
);
export const loadLandRegistriesFailure = createAction(
  '[LandRegistry] Load LandRegistries Failure',
  props<{ error: any }>()
);

export const addLandRegistry = createAction(
  '[LandRegistry] Add LandRegistry',
  props<{ landRegistry: LandRegistry }>()
);
export const addLandRegistrySuccess = createAction(
  '[LandRegistry] Add LandRegistry Success',
  props<{ landRegistry: LandRegistry }>()
);
export const addLandRegistryFailure = createAction(
  '[LandRegistry] Add LandRegistry Failure',
  props<{ error: any }>()
);

export const updateLandRegistry = createAction(
  '[LandRegistry] Update LandRegistry',
  props<{ landRegistry: LandRegistry }>()
);
export const updateLandRegistrySuccess = createAction(
  '[LandRegistry] Update LandRegistry Success',
  props<{ landRegistry: LandRegistry }>()
);
export const updateLandRegistryFailure = createAction(
  '[LandRegistry] Update LandRegistry Failure',
  props<{ error: any }>()
);

export const deleteLandRegistry = createAction(
  '[LandRegistry] Delete LandRegistry',
  props<{ id: number }>()
);
export const deleteLandRegistrySuccess = createAction(
  '[LandRegistry] Delete LandRegistry Success',
  props<{ id: number }>()
);
export const deleteLandRegistryFailure = createAction(
  '[LandRegistry] Delete LandRegistry Failure',
  props<{ error: any }>()
);
